import { IMAGE_UPLOAD_MAX_BYTES } from './constants';
import { compressImageElementOnCanvas } from './compressCanvas';

export type CompressImageFileOptions = {
  /** 尽力压缩后仍超过上限时的回调（由各端注入 toast / message）。 */
  onStillOversized?: () => void;
};

function loadImageFromFile(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('图片读取失败'));
    };
    image.src = objectUrl;
  });
}

function buildCompressedFile(file: File, blob: Blob): File {
  const baseName = file.name.replace(/\.[^.]+$/, '') || 'image';
  return new File([blob], `${baseName}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });
}

/** 超过 2MB 时用 Canvas 迭代降低质量并必要时缩放尺寸。 */
export async function compressImageFileIfNeeded(
  file: File,
  options?: CompressImageFileOptions,
): Promise<File> {
  if (!file.type.startsWith('image/')) {
    return file;
  }
  if (file.size <= IMAGE_UPLOAD_MAX_BYTES) {
    return file;
  }

  const image = await loadImageFromFile(file);
  const blob = await compressImageElementOnCanvas(image, options);
  return buildCompressedFile(file, blob);
}
